module.exports = "<div class=\"col-md-12 footer-section\">\r\n \r\n</div>"